'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupCode$() {
  this.c6Q = null;
  this.c6R = false;
  this.c6O = null;
  this.c6P = false;
}
export { $c_Lpresto_types$GroupCode$ as $c_Lpresto_types$GroupCode$ };
$p = $c_Lpresto_types$GroupCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupCode$;
/** @constructor */
function $h_Lpresto_types$GroupCode$() {
}
export { $h_Lpresto_types$GroupCode$ as $h_Lpresto_types$GroupCode$ };
$h_Lpresto_types$GroupCode$.prototype = $p;
$p.jV = (function() {
  if ((!this.c6R)) {
    this.c6Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c6R = true;
  }
  return this.c6Q;
});
$p.iJ = (function() {
  if ((!this.c6P)) {
    this.c6O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c6P = true;
  }
  return this.c6O;
});
var $d_Lpresto_types$GroupCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupCode$, "presto.types$GroupCode$", ({
  a07: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupCode$ as $d_Lpresto_types$GroupCode$ };
var $n_Lpresto_types$GroupCode$;
function $m_Lpresto_types$GroupCode$() {
  if ((!$n_Lpresto_types$GroupCode$)) {
    $n_Lpresto_types$GroupCode$ = new $c_Lpresto_types$GroupCode$();
  }
  return $n_Lpresto_types$GroupCode$;
}
export { $m_Lpresto_types$GroupCode$ as $m_Lpresto_types$GroupCode$ };
//# sourceMappingURL=presto.types$-Group-Code$.js.map
